/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import LoadingMore from '@src/mobile/components/LoadingMore';
import Tloader from '@src/mobile/components/Tloader';
import EventList from '@src/mobile/components/EventList';
import { EVENT_LIST_PAGE } from '@src/public/constants';
import { changeEventList, changeEventListType } from '../utils';
import { ListStore } from '../store';
import styles from './index.css';
import Filter from './Filter';
import Spin from './Spin';
import NoData from './NoData';
import { isGrounds } from '@src/public/utils/app';
import ThrottleMore from '../throttleMore';

const Main = () => {
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const {
        qrcode,
        listLoading,
        id,
        page,
        size,
        party,
        highlights,
        order,
        total,
        nodes,
        allFold,
        parties,
        title,
        allowComment,
        summary,
        shareImgUrl,
        cutOff,
        list2Ad
    } = listStates;
    const [canCutOff, setCanCutOff] = useState(false);

    useEffect(() => {
        const hasCutOffFlag = localStorage.getItem(id);

        if (hasCutOffFlag) {
            setCanCutOff(true);
        } else {
            // 向本地计数
            let number = parseInt(localStorage.getItem(`${id}number`) || '1');

            if (number > 2) {
                const floorNumber = Math.floor(Math.random() * 10);

                if (floorNumber < 2) {
                    setCanCutOff(true);
                    localStorage.setItem(id, '1');
                }
            } else {
                localStorage.setItem(`${id}number`, ++number);
            }
        }

    }, []);

    const refreshData = async (resolve, reject, reset) => {
        window.timelineReset = reset;

        try {
            await changeEventList({
                query: {
                    id,
                    page: 1,
                    size,
                    party,
                    highlights,
                    order,
                },
                type: changeEventListType.refresh,
                changeData: changeListStates,
            });

            resolve();
        } catch (e) {
            console.error(e);
            reject();
        }
    };

    const loadMoreData = async () => {
        let statusText = 'error';

        try {
            if ((page - 1) * size < total) {
                await changeEventList({
                    query: {
                        id,
                        page,
                        size,
                        party,
                        highlights,
                        order,
                    },
                    type: changeEventListType.more,
                    changeData: changeListStates,
                    prevNodes: nodes,
                });

                statusText = 'success';
            } else {
                statusText = 'end';
            }
        } catch (e) {
            console.error(e);
        }

        return statusText; 
    };

    return (
        <div className={styles.wrap}>
            <Filter />
            <Tloader onRefresh={refreshData}>
                {!listLoading && nodes.length > 0 ? (
                    <>
                        <div className={styles.listWrap}>
                            <EventList
                                content={{
                                    nodes,
                                    parties,
                                    timeline: {
                                        id,
                                        title,
                                        allowComment,
                                        summary,
                                        qrcode,
                                        shareImgUrl
                                    },
                                    list2Ad
                                }}
                                showType={EVENT_LIST_PAGE}
                                allFold={allFold}
                                changeAllFold={bool => {
                                    changeListStates({ allFold: bool });
                                }}
                            />
                        </div>
                        {!isGrounds ? (
                            cutOff && canCutOff ? (
                                <ThrottleMore />
                            ) : (
                                <div>
                                    <LoadingMore control={loadMoreData} />
                                    <ThrottleMore />
                                </div>
                            )
                        ) : (
                            <LoadingMore control={loadMoreData} />
                        )}
                    </>
                ) : null}
            </Tloader>
            {listLoading ? <Spin /> : <>{nodes.length > 0 ? null : <NoData />}</>}
        </div>
    );
};

export default errorBoundary(Main);
